import React from "react";

class ConfirmDialog extends React.Component {
  toggleModal = () => this.props.toggleModal();
  closeModal = () => this.props.closeAction();
  render() {
    let { show, title, message } = this.props;
    const width = "600px";
    const height = "100px";

    return (
      <React.Fragment>
        <div
          className={show ? "modal fade show " : "modal fade"}
          data-backdrop="static"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="staticBackdrop"
          aria-hidden="true"
          style={{ display: show ? "block" : "none" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: width }}
          >
            <div className="modal-content">
              <button
                type="button"
                className="close linear-gradient"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.closeModal}
              >
                X
              </button>
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: height, overflowX: "auto" }}
              >
                <div className="px-4 text-left"> {message ? message : null}</div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
                  data-dismiss="modal"
                  onClick={this.closeModal}
                >
                  <span>No</span>
                </button>
                <button
                  type="button"
                  onClick={this.toggleModal}
                  className="btn linear-gradient yr-submitbtn btn-sm"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ConfirmDialog;
